// Modules
import cn from 'classnames';

// Types
import type { TCardHeaderProps } from './Card.type';

// Styles
import styles from './styles.module.scss';

const CardHeader = (props: TCardHeaderProps) => {
  const {
    className,
    contentClassName,
    contentStyle,
    description,
    descriptionClassName,
    descriptionStyle,
    iconLeft,
    iconLeftClassName,
    iconLeftStyle,
    iconRight,
    iconRightClassName,
    iconRightStyle,
    noDivider,
    title,
    titleClassName,
    titleStyle,
    ...restProps
  } = props;

  const cardHeaderCN = cn(className, styles.legion_card_header, {
    [styles.full_content]: !!title && !!description,
    [styles.no_divider]: noDivider
  });
  const contentCN = cn(contentClassName, styles.header_content);
  const descriptionCN = cn(descriptionClassName, styles.header_description);
  const iconLeftCN = cn(iconLeftClassName, styles.icon_left);
  const iconRightCN = cn(iconRightClassName, styles.icon_right);
  const titleCN = cn(titleClassName, styles.header_title);

  return (
    <div className={cardHeaderCN} {...restProps}>
      {iconLeft && <div className={iconLeftCN} style={iconLeftStyle}>{iconLeft}</div>}
      <div className={contentCN} style={contentStyle}>
        {title && <h3 className={titleCN} style={titleStyle}>{title}</h3>}
        {description && <p className={descriptionCN} style={descriptionStyle}>{description}</p>}
      </div>
      {iconRight && <div className={iconRightCN} style={iconRightStyle}>{iconRight}</div>}
    </div>
  );
};

CardHeader.displayName = 'CardHeader';
export default CardHeader;
